import React from "react";

import ResponsiveContent from "@stadium/ui/src/contexts/responsive-content";

const PrismicGlobalConfigContext = React.createContext({});

const { Provider } = PrismicGlobalConfigContext;

const PrismicGlobalConfigWrapper = ({ value, children }) => (
  <ResponsiveContent>
    <Provider value={value}>{children}</Provider>
  </ResponsiveContent>
);
export { PrismicGlobalConfigWrapper, PrismicGlobalConfigContext };
